import { getElapsedTime } from '@utility/fireboardUtil';
import { getFireboardChecks } from '@utility/rethink-utils.js';
import constant from '@components/common/globalization'
import Aux from '../../components/Fireboard/components/AuxComponent/index';
export const getDueTime = check => {
  return check.pickupDate || check.orderDate || check.openDate;
};
export const getChecksList = (
  checks,
  orderType,
  storeInfo,
  activeCheckFilter,
) => {

  const deviceGroup = JSON.parse(window.sessionStorage.getItem('deviceInfo'))?.deviceGroup

  const prepWindow = storeInfo?.prepWindow;
  let checkList = [];
  const filterByOneDineChannel = (item) => {
    const filters = deviceGroup?.fireBoardCheckFilters || [];

    const res = Array.isArray(filters) ? filters : [];
    if (!res?.length) return true;
    // if (item.sourceType === 0) {
    // if (item.tab === false) return res.includes(0);
    // if (item.tab === true) return res.includes(1);
    // return res.includes(0) || res.includes(1);
    // }
    return res.includes(item.sourceType);
  };

  const getFireboardChecksBasedOnOrderType = (checks, orderTypes, selectedType) => {
    const allChecks = [];
    checks.forEach(checkHeader => {
      orderTypes.forEach(eachType => {
        if (eachType.id === checkHeader.orderTypeId && eachType.id === selectedType.id) {
          allChecks.push(checkHeader);
        }
      });
    });
    return allChecks;
  }

  const getFireboardChecksBasedOnRevenueType = (checks, revenueTypes, selectedType) => {
    const allChecks = [];
    checks.forEach(checkHeader => {
      revenueTypes.forEach(eachType => {
        if (eachType.id === checkHeader.revenueCenterId && eachType.id === selectedType.id) {
          allChecks.push(checkHeader);
        }
      });
    });
    return allChecks;
  }

  if (orderType === 'All') {
    const filteredChecks = Array.from(checks.values()).filter(item => {
      if (deviceGroup?.fireBoardCheckFilterType === 0) {
        return filterByOneDineChannel(item);
      }
      return true;
    });

    checkList.push(...filteredChecks);
  } else if (activeCheckFilter === "sourceType") {
    checkList = getFireboardChecks(
      checks,
      orderType?.value === constant.kioskMode,
      orderType?.value === constant.curbSideOrder,
      orderType?.value === constant.onlineOrder,
      orderType?.value === constant.walkUpMode,
      orderType?.value === constant.orderType_POS,
      orderType?.value === constant.CALL_CENTER,
      orderType?.value === constant.orderType_speedOrder,
      orderType?.value === constant.CALL_IN,
      orderType?.value === constant.COUNTER,
      orderType?.value === constant.orderType_driveThru,
      orderType?.value === constant.ORDER_PAY,
    )
  } else if (activeCheckFilter === 'orderType') {
    return getFireboardChecksBasedOnOrderType(
      checks,
      storeInfo.orderTypes,
      orderType
    )
  } else if (activeCheckFilter === 'revenueCenter') {
    return getFireboardChecksBasedOnRevenueType(
      checks,
      storeInfo.revenueCenters,
      orderType
    );
  }

  const updatedChecksList = checkList.reduce((result, check) => {
    if (check.orderStatusId !== 10) {
      const dueTime = getDueTime(check);
      result.push({
        ...check,
        elapsedTime: getElapsedTime(check, prepWindow),
        dueTime: new Date(dueTime).getTime(),
        dueTimeDisplay: dueTime,
      });
    }
    return result;
  }, []);

  return updatedChecksList;
};

export const parseCheck = check => {
  const order = check?.orders[0];
  let orderObj = {};
  if (order !== null && order !== undefined) {
    orderObj = {
      checkedIn: order.checkedIn,
      checkHeaderReferenceId: check.referenceId,
      checkInDate: order.checkInDate,
      checkInNote: order.checkInNote,
      checkNumber: check.number,
      checkOrderId: order.id,
      checkOrderReferenceId: order.referenceId,
      completedDate: order.completedDate,
      orderDate: order.orderDate,
      orderStatusId: order.orderStatusId,
      phoneNumber: order.phoneNumber,
      pickupDate: order.pickupDate,
      checkHeaderId: check.id,
    };
  } else {
    orderObj = {
      checkedIn: false,
      checkHeaderReferenceId: check.referenceId,
      checkInDate: null,
      checkInNote: null,
      checkNumber: check.number,
      checkOrderId: 0,
      checkOrderReferenceId: null,
      completedDate: null,
      orderDate: check.openDate,
      orderStatusId: 0,
      phoneNumber: null,
      pickupDate: null,
      checkHeaderId: check.id,
    };
  }
  const parsedCheck = {
    ...check,
    items:
      check?.items?.map(item => ({
        ...item,
        checkItemId: item.id,
      })),
    ...orderObj,
  };
  return parsedCheck;
};

export const sortModifierFunc = (a, b) => {
  if (a?.modifierId == b?.modifierId) return 0;
  return (a?.modifierId > b?.modifierId) ? 1 : -1;
};

export const renderModifiersRecursively = (
  item,
  modifierRenderer,
  itemRenderer,
  checkModifiers,
  index = 0,
) => {
  // Helper function to parse modifiers
  const modifierParser = (i) => {
    const modifiers = [];
    if (i.modifiers && Array.isArray(i.modifiers)) {
      i.modifiers.sort(sortModifierFunc).forEach((m) => {
        const modifier = renderModifiersRecursively(
          m,
          modifierRenderer,
          modifierRenderer,
          checkModifiers,
          index + 1,
        );
        modifiers.push(modifier);

        if (m.repeatedModifiers) {
          const repeatedModifiers = m.repeatedModifiers.map((repeatedModifier) =>
            renderModifiersRecursively(
              repeatedModifier,
              modifierRenderer,
              modifierRenderer,
              checkModifiers,
              index + 1,
            )
          );
          modifiers.push(repeatedModifiers);
        }
      });
    }
    return modifiers;
  };

  let modifierSelection;

  // Determine how to parse modifiers
  if (checkModifiers) {
    modifierSelection = modifierParser(item);
  } else if (item.modifierGroups) {
    modifierSelection = item.modifierGroups.map((mg) => modifierParser(mg));
  }

  // Render the item and its modifiers
  return (
    <Aux className='col-12 px-0'>
      {itemRenderer(item, index)}
      <div className='col-12 pl-3 pr-0'>{modifierSelection}</div>
    </Aux>
  );
};

export const getAllSelectedChecks = (checks, filters, storeInfo) => {
  const {
    activeCheckFilter,
    sourceTypes,
  } = filters;
  if ((activeCheckFilter === 'sourceType' && sourceTypes.length === 0)) {
    return checks
  }
}